export function findMarkerById(
  markers: Array<jigsaw.Marker>,
  globalId: string
) {
  const marker = markers.find(o => o.globalId === globalId);
  return marker;
}

export function isEmojiMarker(label: string) {
  return label === "Emoji Note Marker";
}
